import organization from "@/apis/organization";

export default {
  namespaced: true,
  state: {
    modules: [],
  },
  getters: {
    getModule: (state) => (code, merchantId = null) => {
      return merchantId
        ? state.modules.find(module => module.module_code === code && module.merchant_id === merchantId)
        : state.modules.find(module => module.module_code === code)
    },
    getConfig: (state, getters) => (code, configKey, merchantId = null) => {
      let module = getters.getModule(code, merchantId)
      if (!module) return undefined

      const keys = configKey.split("."); // 將 key 字串以 . 分隔成陣列
      return keys.reduce((obj, key) => obj ? obj[key] : undefined, module.module_config);
    },
    getConfigWithMerchant: (state, getters) => (code, configKey, merchantId) => {
      return getters.getConfig(code, configKey, merchantId)
    },
  },
  mutations: {
    SET_MODULE(state, module) {
      if (!state.modules.find((m) => m.module_code === module.module_code)) {
        state.modules.push(module)
      }
    },
    SET_MODULE_WITH_MERCHANT(state, module) {
      if (!state.modules.find((m) => m.module_code === module.module_code && m.merchant_id === module.merchant_id)) {
        state.modules.push(module)
      }
    },
    RESET_MODULES(state) {
      state.modules = [];
    },
  },
  actions: {
    async fetchModule (context, params) {
      if (context.getters.getModule(params.code)) {
        console.debug(`module loaded`, params.code)
        return
      }
      try {
        const { data } = await organization.getModuleConfig(params.org_id, { module_code: params.code });
        context.commit('SET_MODULE', { module_code: params.code, module_config: data })
        console.debug('fetch module', data)
      } catch (error) {
        if (error.status !== 401 && error.status !== 403) {
          context.commit('SET_MODULE', { module_code: params.code, module_config: {} })
        }
      }
    },
    // 同一間 org 的不同 merchant 可能有相同名稱的 module，這個會將所有 module 抓下來，再根據 merchant_id 取資料
    // 不過也存在一個 org 只有一個 module 的情況，所以還是需要 fetchModule
    async fetchModules(context, params) {
      if (context.getters.getModule(params.code)) {
        return
      }

      try {
        const { data } = await organization.getModuleConfigs(params.org_id, { module_code: params.code });
        data.forEach(module => {
          context.commit('SET_MODULE_WITH_MERCHANT', module)
        })
      } catch (error) {
        console.log(error)
        if (error.status !== 401 && error.status !== 403) {
          context.commit('SET_MODULE', { module_code: params.code, module_config: {} })
        }
      }
    },
    resetModules (context) {
      context.commit('RESET_MODULES');
    },
  },
};
